module.exports = __webpack_public_path__ + "statics/img/4.5100539.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/solution/4.png
// module id = SkEA
// module chunks = 1